// extracted by mini-css-extract-plugin
export default {"divBody":"style_divBody__hRH30","iconWrap":"style_iconWrap__BNlSR","groupItemIcon":"style_groupItemIcon__Nlq2A"};